import { HintMap } from '@/models/common/hint/hint-map.model';
import { PayoutOrderHintNames } from '@/models/payout-order/payout-order-hint-names.model';

export const PAYOUT_ORDER_HINT_MAP: HintMap = {
  [PayoutOrderHintNames.TAGS]: {
    title: 'Tags',
    description: 'Enter at least two characters to start the search',
  },
  [PayoutOrderHintNames.SEGMENTS]: {
    title: 'Segments',
    description: 'Enter at least two characters to start the search',
  },
};
